import getAnneeSemaine from '@/services/general/getAnneeSemaine';

export default async function validation(response, messages, reseaux) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  const i18nType = 'validationDevis';

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FACE_NOT_AVAILABLE') === 0) {
      const elements = message.split('|')[0].split('@');
      const reseau = reseaux.find(r => {
        const anneeSemaine = getAnneeSemaine(
          r.extensionOpportunite.annee,
          r.extensionOpportunite.semaine,
        );
        return r.num === elements[3] && anneeSemaine === elements[2];
      });
      if (!reseau) {
        messages.push({ message: i18nType + '.faceNotAvailable' });
        return;
      }
      reseau.listeFaces.forEach((f) => {
        if (f.facNum === elements[1] || f.idProduit === elements[1]) {
          messages.push({
            message: i18nType + '.faceNotAvailableInSelection',
            parametres: { face: f.facCode, reseau: reseau.libelle, semaine: elements[2] },
          });
        }
      });
    }
    if (message.indexOf('AMOUNT_SELECTED_IS_GREATER_THAN_AMOUNT_WISH') === 0) {
      messages.push({
        message: i18nType + '.faceSelectGreaterThanFaceWish',
      });
    }
    if (message.indexOf('LINE_S_STATE_MUST_BE_BLOQUE') === 0) {
      messages.push({
        message: i18nType + '.lineMustBeBloque',
      });
    }
    if (message.indexOf('NO_CHANGE_PARUTION_IN_LIGNE_COMMANDE_WITH_ENCART_CHEMIN_FER') === 0) {
      messages.push({
        message: i18nType + '.parutionCheminDeFer',
      });
    }
    if (message.indexOf('ORDER_OR_QUOTE_MUST_BE_NOT_CANCEL') === 0) {
      messages.push({
        message: i18nType + '.devisCommandeNotCancel',
      });
    }
    if (message.indexOf('2_BILLBOARD_IN_SAME_DCF') === 0) {
      const elements = message.split('|')[0].split('@');
      const face = reseaux
        .map(r => r.listeFaces.map(l => ({
          ...l,
          semaineReseau: r.extensionOpportunite.semaine,
          anneeReseau: r.extensionOpportunite.annee,
        }))).flat()
        .find(f => f.facNum === elements[1] || f.idProduit === elements[1]);
      messages.push({
        message: i18nType + '.sameFaceInSameWeek',
        parametres: {
          face: face.facCode,
          semaine: face.semaineReseau,
          annee: face.anneeReseau,
        },
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/validationVentePartielle.js